import { FileSpecification } from 'src/app/models/file-specifications/file-specification';

export function filterStillsSpecs(specs: FileSpecification[]): FileSpecification[] {
  return specs.filter((s) => s.value.settings.media === 'stills');
}

export function filterVideosSpecs(specs: FileSpecification[]): FileSpecification[] {
  return specs.filter((s) => s.value.settings.media === 'videos');
}
